// extracted by mini-css-extract-plugin
export var cancelButton = "_m1-5";
export var content = "_m1-3";
export var createButton = "_m1-6";
export var drawerContainer = "_m1-0";
export var footer = "_m1-2";
export var header = "_m1-1";
export var orderFormColumn = "_m1-4";